/* eslint-disable eqeqeq */
import FilterUtils from './FilterUtils';

export default class PlanUtils {
  static getIntermediates(segments) {
    let res = '';
    for (let i = 0; i < segments.length; i++) {
      if (i !== 0 && i !== segments.length - 1 && segments[i]?.location) {
        res += segments[i].location.latitude + ',' + segments[i].location.longitude + ',';
      }
    }
    res = res.slice(0, -1);
    return res;
  }

  /* Función que devuelve si la localización pasada se encuentra lejana al centro del mapa */
  static checkLocation(location) {
    if (!location) {
      return false;
    }
    const centerMap = { latitude: 43.030244, longitude: -2.593833 };
    if (
      Math.abs(Math.abs(location.longitude) - Math.abs(centerMap.longitude)) > 1.39 ||
      Math.abs(Math.abs(location.latitude) - Math.abs(centerMap.latitude)) > 0.8
    ) {
      return false;
    }
    return true;
  }

  /**
   * @function getTypeId sirve para obtener el id del tipo de lugar
   */
  static getTypeId(typePlace: string, isFavorite?: boolean) {
    let typeId: number = 2;
    if (isFavorite) {
      return typeId;
    }
    switch (typePlace) {
      case 'stop':
        typeId = 0;
        break;
      case 'poi':
        typeId = 1;
        break;
      case 'direction':
      default:
        typeId = 3;
        break;
    }
    return typeId;
  }

  static getPlaceElement(typeId: number, id: any) {
    return `{'typeId': ${typeId};'value':${id}}`.replace(/["']/g, '');
  }

  static getIntermediatesPlaces(segments: Array<any>, favorites: any) {
    let intermediates = '';
    for (let i = 0; i < segments.length; i++) {
      if (i !== 0 && i !== segments.length - 1 && segments[i]?.location) {
        intermediates +=
          PlanUtils.getPlaceElement(
            PlanUtils.getTypeId(
              segments[i].place.typeId,
              FilterUtils.checkFavorite(segments[i], favorites),
            ),
            segments[i].place.id,
          ) + '_';
      }
    }
    intermediates = intermediates.slice(0, intermediates.length - 1);
    return intermediates;
  }

  /**
   * @function allSegmentsHaveValues controla si todos los segmentos del planificador presentan un valor
   */
  static allSegmentsHaveValues(segments: Array<any>) {
    let haveValues = true;
    let i = 0;
    while (i < segments.length && haveValues) {
      if (!segments[i]) {
        haveValues = false;
      }
      i = i + 1;
    }
    return haveValues;
  }

  /**
   * @function cleanJoinPlan elimina del resultado de planificación @param res con los itinerarios
   * juntados aquellos itinerarios que se hayan señalado como incorrectos
   */
  static cleanJoinPlan(res: any, indexesToDelete: Array<number>) {
    indexesToDelete.sort(function (a, b) {
      return a - b;
    });

    for (let i = indexesToDelete.length - 1; i >= 0; i--) {
      res.plan.itineraries.splice(indexesToDelete[i], 1);
    }
    return res;
  }

  static formatPoint(point) {
    let res = {};
    if (point?.position) {
      res['name'] = point?.name;
      res['desc'] = point?.desc;
      res['location'] = point?.position
        ? { latitude: point?.position?.lat, longitude: point?.position?.lng }
        : null;
      res['id'] = point?.id;
      res['icon'] = point?.icon;
    } else if (point?.stopName) {
      res['name'] = point?.stopName;
      res['desc'] = point?.stopDesc;
      res['location'] = point?.stopLon
        ? { latitude: point?.stopLat, longitude: point?.stopLon }
        : null;
      res['id'] = point?.id;
      res['icon'] = point?.icon;
    } else if (point.via && point.street) {
      // DIRECCION
      let name = point.via ? point.via : '';
      name = point.street ? name + ' ' + point.street : name;
      name = point.portal && point.portal != 0 ? name + ', ' + point.portal : name;
      res['name'] = name;
      res['desc'] = point.municipality ? point.municipality : '';
      res['location'] = { latitude: point?.latitude, longitude: point?.longitude };
      res['id'] = point?.longitude + point?.latitude;
    } else if (point.street) {
      // CARRETERA
      let name = point.street ? point.street : '';
      name = point.portal && point.portal != 0 ? name + ', ' + point.portal : name;

      res['name'] = name;
      res['desc'] = point.municipality ? point.municipality : '';
      res['location'] = { latitude: point?.latitude, longitude: point?.longitude };
      res['id'] = point?.longitude + point?.latitude;
    } else {
      // MUNICIPIO
      res['name'] = point.municipality ? point.municipality : '';
      res['desc'] = '';
      res['location'] = { latitude: point?.latitude, longitude: point?.longitude };
      res['id'] = point?.longitude + point?.latitude;
    }
    return res;
  }

  static itsCoords(coords) {
    let arrayCoords = coords.split([',']);
    if (
      arrayCoords.length === 2 &&
      !isNaN(parseFloat(arrayCoords[0])) &&
      !isNaN(parseFloat(arrayCoords[1])) &&
      90 > parseFloat(arrayCoords[0]) &&
      parseFloat(arrayCoords[0]) > -90 &&
      180 > parseFloat(arrayCoords[1]) &&
      parseFloat(arrayCoords[1]) > -180
    )
      return arrayCoords;
    else return false;
  }

  static goTo = (id, block) => {
    document
      .getElementById(id)
      ?.scrollIntoView({ behavior: 'smooth', block, inline: 'nearest' });
  };

  static getMidPoint(point1, point2) {
    if (!point1 || !point2) return null; // Retorna nulo si los puntos no son válidos

    // Conversión de las coordenadas a flotantes para evitar errores
    const lat1 = parseFloat(point1.latitude);
    const lon1 = parseFloat(point1.longitude);
    const lat2 = parseFloat(point2.latitude);
    const lon2 = parseFloat(point2.longitude);

    if (isNaN(lat1) || isNaN(lon1) || isNaN(lat2) || isNaN(lon2)) return null; // Validación extra

    // Calcular el punto medio
    return {
      lat: (lat1 + lat2) / 2,
      lng: (lon1 + lon2) / 2,
    };
  }

  static getMidZoom(point1, point2) {
    if (!point1 || !point2) return 18; // Zoom predeterminado
    const { latitude: lat1, longitude: lon1 } = point1;
    const { latitude: lat2, longitude: lon2 } = point2;

    if (
      isNaN(parseFloat(lat1)) ||
      isNaN(parseFloat(lon1)) ||
      isNaN(parseFloat(lat2)) ||
      isNaN(parseFloat(lon2))
    ) {
      return 18; // Zoom predeterminado
    }

    if (lon1 === lon2 && lat1 === lat2) return 18;

    const toRadians = (degrees) => degrees * (Math.PI / 180);

    const radLat1 = toRadians(lat1);
    const radLat2 = toRadians(lat2);
    const radLonDiff = toRadians(lon1 - lon2);

    const cosineDistance =
      Math.sin(radLat1) * Math.sin(radLat2) +
      Math.cos(radLat1) * Math.cos(radLat2) * Math.cos(radLonDiff);

    const safeCosineDistance = Math.min(1, Math.max(-1, cosineDistance));

    const distance = 6371 * Math.acos(safeCosineDistance);

    // Ajustar el zoom según la distancia y el tamaño de la pantalla
    const screenWidth = window.innerWidth;
    let zoom;

    if (distance < 0.4) zoom = 17;
    else if (distance < 1) zoom = 16;
    else if (distance < 3) zoom = 15;
    else if (distance < 5) zoom = 15;
    else if (distance < 10) zoom = 14;
    else if (distance < 25) zoom = 13;
    else if (distance < 50) zoom = 12;
    else if (distance < 100) zoom = 11;
    else zoom = 9;

    // Reducir el zoom para pantallas pequeñas
    if (screenWidth < 768) {
      zoom = Math.max(12, zoom - 2);
    }

    return zoom;
  }

  // static getMidPoint(point1, point2) {
  //   if (parseFloat(point2?.longitude) < parseFloat(point1?.longitude))
  //     return {
  //       lat: (parseFloat(point1?.latitude) + parseFloat(point2?.latitude)) / 2,
  //       lng: (parseFloat(point1?.longitude) + parseFloat(point2?.longitude) * 3) / 4,
  //     };
  //   else
  //     return {
  //       lat: (parseFloat(point1?.latitude) + parseFloat(point2?.latitude)) / 2,
  //       lng: (parseFloat(point1?.longitude) * 3 + parseFloat(point2?.longitude)) / 4,
  //     };
  // }

  // static getMidZoom(point1, point2) {
  //   let longitude1 = point1?.longitude;
  //   let longitude2 = point2?.longitude;
  //   let latitude1 = point1?.latitude;
  //   let latitude2 = point2?.latitude;
  //   let theta = longitude1 - longitude2;
  //   if (longitude1 === longitude2 && latitude1 === latitude2 ) return 18;
  //   let distance =
  //   60 *
  //   1.1515 *
  //   (180 / Math.PI) *
  //   Math.acos(
  //     Math.sin(latitude1 * (Math.PI / 180)) * Math.sin(latitude2 * (Math.PI / 180)) +
  //     Math.cos(latitude1 * (Math.PI / 180)) *
  //     Math.cos(latitude2 * (Math.PI / 180)) *
  //     Math.cos(theta * (Math.PI / 180)),
  //     );
  //   let res = distance * 1.609344;
  //   if (res >= 0 && res < 0.4) return 18;
  //   if (res >= 0.4 && res < 1) return 17;
  //   if (res >= 1 && res < 3) return 16;
  //   if (res >= 3 && res < 5) return 15;
  //   if (res >= 5 && res < 10) return 14;
  //   if (res >= 10 && res < 25) return 13;
  //   if (res >= 25 && res < 50) return 12;
  //   if (res >= 50 && res < 100) return 11;
  //   if (res >= 100) return 9;
  //   const screenWidth = window.innerWidth;
  //   // Reducir el zoom para pantallas pequeñas
  //   if (screenWidth < 768) {
  //     res = Math.max(12, res - 3);
  //   }

  //   return res;
  // }

}
